
import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
	selector: 'app-bread-crumb',
	templateUrl: './bread-crumb.component.html',
	styleUrls: ['./bread-crumb.component.scss']
})
export class BreadCrumbComponent implements OnInit, OnDestroy {
	
	@Input() Locations: { target: string; label: string } [];
	@Input() current: string = '';
	

	constructor() 
	{

	}

	ngOnInit(): void {
		
	}


	ngOnDestroy(): void {

	}
	

	onLinkClicked = (event : any) => {
		event?.preventDefault();
		"function" === typeof(event?.stopPropogation) && event?.stopPropogation();
		"function" === typeof(event?.stopImmediatePropogation) && event?.stopImmediatePropogation();
	}
}
